export const environment = {
    production: false,
    config: {
        appName: 'Primăria Sectorului 4',
        appDescription: 'inUrbanism Sector 4',
        fromTokenValid:
            'https://development.auth-core.webproductionlabs.com/api/login',
        tokenKey: 'wpl-staging-operator-app-token', // this token is used for every request where is needed
        userKey: 'wpl-staging-operator-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-staging-operator', // here we find key for predefined local storage for app functionalities
        copyrightText: 'Copyright © Direcția de Urbanism Sector 4 - 2023',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 30,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Succes',
                error: 'Eroare',
                successForm: 'Felicitări!',
            },
            generalMessages: {
                error:
                    'Ne pare rau, dar am întampinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.',
            },
        },
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _TOTAL_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioară',
            },
            oAria: {
                sSortAscending: ': activează pentru a sorta coloana crescător',
                sSortDescending: ': activează pentru a sorta coloana descrescător',
            },
        },
    },
    interop: {
        basePath: 'https://development.urb-core.webproductionlabs.com/',
        clientId: 7,
        moduleId: 2,
        urbanism: {
            authorizeShortToken: 'authorization_code/',
            notifications: {
                authNotifications: 'api/cerere/auth-notifications',
            },
            settings: {
                configurations: {
                    // PLATFORM CONFIGURATION - URBANISM
                    getConfigurations: 'api/settings/configuration/list',
                    getConfigurationsDT: 'api/settings/configuration/list-dt',
                    getSlugConfiguration: 'api/settings/configuration/find/', // + slug
                    getConfiguration: 'api/settings/configuration/one/', // + id
                    putConfiguration: 'api/settings/configuration/update', // id in payload
                    storeConfiguration: 'api/settings/configuration/store',
                },
            },
            cerere: {
                getCereriList: 'api/cerere/list',
                getCereriListDT: 'api/cerere/list-dt',
                findCerere: 'api/cerere/find/', // + id
                storeCereri: 'api/cerere/store',
                updateCereri: 'api/cerere/update',
                deleteCereri: 'api/cerere/delete/', // + id
                getInfoDocList: 'api/cerere/getInformationsDocumentsList/', // + id
                updateStatus: 'api/cerere/update-status/', // + id
                updatePriority: 'api/cerere/update-priority/', // + id
                updateAssignee: 'api/cerere/update-asignee/', // + id
                postMessage: 'api/cerere/post-message/', // + id
                rePostMessage: 'api/cerere/re-post-message/', // + id

                downloadDocument: 'api/cerere/download-document/', // + id
                downloadDocumentAnexa: 'api/cerere/download-document-anexa/', // + id

                downloadManual: 'api/cerere/manual',

                preluarePersonala: 'api/cerere/preluare-cerere/', // + id
                preluareNumarRegistratura: 'api/cerere/generate-reg-number/', // + id
                validateCerere: 'api/cerere/validate/', // + id
                invalidateCerere: 'api/cerere/invalidate/', // + id
                anulareCerere: 'api/cerere/anulare/', // + id
                finalizareCerere: 'api/cerere/finalize-cerere/', // + id

                massAssign: 'api/cerere/update-mass-asignee', // id in payload
                massUpdateStatus: 'api/cerere/update-mass-status',

                editValabilitateDocGenerabil: 'api/cerere/edit-document-valability/', // + id

                file: {
                    fileUpload: 'api/cerere/upload-file',
                    fileUploadBase64: 'api/cerere/upload-file-base64',
                },

                uploadOnlineDocument: 'api/cerere/upload-online-document/', // id cerere

                // special operations
                generateDocument: 'api/cerere/generare-document/', // id => id_cerere, templateId => templateId
                validateDocument: 'api/cerere/validate-document/', // id
                validateDocumentSuperior: 'api/cerere-validate-superior/', // id => id_cerere, documentId => documentId
                cancelDocumentSuperior: 'api/cerere-anulare-superior/', // id => documentId
                // validateDocumentByUpload: 'api/cerere/validate-document/', // id document
                generareDraft: 'api/cerere/precompletare/',
                resetDocumentValidated: 'api/cerere/reset-document/', // id document
                resetDocumentIntocmitorValidated:
                    'api/cerere/reset-document-intocmitor/', // id document
                uploadedFinalDocument: 'api/cerere/upload-document-oficial/', // id document
                addToRegistru: 'api/cerere-registru-add/', // cerereId, documentId
                downloadDocumentOfficial: 'api/cerere/download-document-oficial/', // id document
                downloadDocumentGenerat: 'api/cerere/download-document-generat/', // id document
                downloadDocumentSigned: 'api/cerere/download-document-signed/', // id => documentId
                downloadDocumentSignatureSigned:
                    'api/cerere/download-document-signature-signed/', // id => signatureId
                istoricDocument: 'api/cerere/istoric-document/', // id document
                destroyDocument: 'api/cerere/destroy-document/', // id document
                updateDocument: 'api/cerere/update-document/', // id document
                downloadTableSignatures: 'api/cerere/download-approval-table/', // id document

                sendDocumentToIntocmitor: 'api/cerere/send-document-back/', // id => signatureId
                sendDocumentForwardIntocmitor: 'api/cerere/send-document-forward/', // id => documentId
                sendDocumentForwardToSigner:
                    'api/cerere/send-document-forward-superior/', // id => signatureId

                rsyncSignaturesDocumentGenerat: 'api/cerere/reload-document-flow/', // id _ documentId
                exportHistory: 'api/cerere/download-history/', //+ id_cerere + user type (2=> ceteatan, 1=> operator)

                resetValidareCerere: 'api/cerere/reset/validare/', // id_cerere - PUT
                resetinValidareCerere: 'api/cerere/reset/invalidare/', // id_cerere - PUT
                resetClasareCerere: 'api/cerere/reset/clasare/', // id_cerere - PUT
                resetInchidereCerere: 'api/cerere/reset/finalizare/', // id_cerere - POST

                sendNotificationCetateanDocumentOficial:
                    'api/cerere/send-document-oficial-notificare-cetatean/', // id document generat - GET request
                resetDocumentOficialNotificareCetatean:
                    'api/cerere/reset-document-oficial-notificare-cetatean/', // + id
                resetUploadDocumentOfficial:
                    'api/cerere/reset-upload-document-official/', // + id

                cerereUpdateMetadate: 'api/cerere/update-metadate/', // + id cerere

                setDocTypeForDocument: 'api/cerere/document-generat/manually-doc-type/', // + id document generat
                updateCurrentSignatureDocument: 'api/cerere/document-generat/manually-update-user-validation/', // + id document generat

                signatures: {
                    getListIds:
                        'api/cerere/document-generat/signatures/allocated/', // + id document + doc_type
                    updateIds:
                        'api/cerere/document-generat/signatures/allocated/', // + id document
                    // updateOrder:
                    // 	'api/nomenclatoare/document-templates/signatures/update-order/', // + id signature
                    // updateSignType:
                    // 	'api/nomenclatoare/document-templates/signatures/update-sign-type/', // + id
                    updateSignatures:
                        'api/cerere/document-generat/signatures/update-signatures',
                },

                allowMessages: 'api/cerere/allow-messages/', // + id
            },
            nomenclatoare: {
                functie: {
                    // functii operatori from the platform
                    getFunctiiDT: 'api/nomenclatoare/functie/list-dt',
                    getFunctii: 'api/nomenclatoare/functie/list',
                    getFunctiiActive: 'api/nomenclatoare/functie/list/active',
                    getFunctiiActivePublic: 'api/nomenclatoare/functie/list/public',
                    getFunctie: 'api/nomenclatoare/functie/find/', // + id
                    putFunctie: 'api/nomenclatoare/functie/update', // id in payload
                    changeStatusFunctieActive: 'api/nomenclatoare/functie/active/', // + id
                    changeStatusFunctiePublic: 'api/nomenclatoare/functie/public/', // + id
                    deleteFunctie: 'api/nomenclatoare/functie/delete/', // + id
                    storeFunctie: 'api/nomenclatoare/functie/store',
                },
                departament: {
                    getDepartamente: 'api/nomenclatoare/departament/list',
                    getDepartamenteDT: 'api/nomenclatoare/departament/list-dt',
                    getDepartamenteActive: 'api/nomenclatoare/departament/list/active',
                    getDepartamentePublic: 'api/nomenclatoare/departament/list/public',
                    getDepartamentById: 'api/nomenclatoare/departament/find/', // + id
                    storeDepartament: 'api/nomenclatoare/departament/store',
                    updateDepartament: 'api/nomenclatoare/departament/update',
                    deleteDepartament: 'api/nomenclatoare/departament/delete', // + id
                },
                imageType: {
                    // used to resize images to certain sizes
                    getImageTypesDT: 'api/nomenclatoare/image-type/list-dt',
                    postImageType: 'api/nomenclatoare/image-type/store',
                    getImageTypes: 'api/nomenclatoare/image-type/list',
                    getImageType: 'api/nomenclatoare/image-type/find/', // + id
                    putImageType: 'api/nomenclatoare/image-type/update', // id in payload
                    deleteImageType: 'api/nomenclatoare/image-type/delete/', // + id
                },
                cerereType: {
                    getCerereTypes: 'api/nomenclatoare/cerere-type/list',
                    getCerereTypesDT: 'api/nomenclatoare/cerere-type/list-dt',
                    getCerereType: 'api/nomenclatoare/cerere-type/find/', // + id
                    putCerereType: 'api/nomenclatoare/cerere-type/update', // id in payload
                    deleteCerereType: 'api/nomenclatoare/cerere-type/delete/', // + id
                    storeCerereType: 'api/nomenclatoare/cerere-type/store',
                    getCerereTypesActive: 'api/nomenclatoare/cerere-type/list/active',
                    getCerereTypesActivePublic:
                        'api/nomenclatoare/cerere-type/list/public',
                    changeStatusCerereTypeActive: 'api/nomenclatoare/cerere-type/active/', // + id
                    changeStatusCerereTypePublic: 'api/nomenclatoare/cerere-type/public/', // + id
                    clearCache: 'api/nomenclatoare/cerere-type/clear-cache',
                },
                cerereStatus: {
                    getCerereStatuses: 'api/nomenclatoare/cerere-status/list',
                    getCerereStatusesDT: 'api/nomenclatoare/cerere-status/list-dt',
                    getCerereStatus: 'api/nomenclatoare/cerere-status/find/', // + id
                    putCerereStatus: 'api/nomenclatoare/cerere-status/update', // id in payload
                    deleteCerereStatus: 'api/nomenclatoare/cerere-status/delete/', // + id
                    storeCerereStatus: 'api/nomenclatoare/cerere-status/store',
                    getCerereStatusesActive:
                        'api/nomenclatoare/cerere-status/list/active',
                    getCerereStatusesActivePublic:
                        'api/nomenclatoare/cerere-status/list/public',
                    changeStatusCerereStatusActive:
                        'api/nomenclatoare/cerere-status/active/', // + id
                    changeStatusCerereStatusPublic:
                        'api/nomenclatoare/cerere-status/public/', // + id
                    changeStatusCerereArchive: 'api/nomenclatoare/cerere-status/archive/', // + id
                    clearCache: 'api/nomenclatoare/cerere-status/clear-cache',
                    updateOrder: 'api/nomenclatoare/cerere-status/update-order/', // + id => put request
                    rankList: 'api/nomenclatoare/cerere-status/rank-list'
                },
                cererePriority: {
                    getCererePrioritiesDT: 'api/nomenclatoare/cerere-priority/list-dt',
                    getCererePriorities: 'api/nomenclatoare/cerere-priority/list',
                    getCererePriority: 'api/nomenclatoare/cerere-priority/find/', // + id
                    putCererePriority: 'api/nomenclatoare/cerere-priority/update', // id in payload
                    deleteCererePriority: 'api/nomenclatoare/cerere-priority/delete/', // + id
                    storeCererePriority: 'api/nomenclatoare/cerere-priority/store',
                    getCererePrioritiesActive:
                        'api/nomenclatoare/cerere-priority/list/active',
                    getCererePrioritiesActivePublic:
                        'api/nomenclatoare/cerere-priority/list/public',
                    changeStatusCererePriorityActive:
                        'api/nomenclatoare/cerere-priority/active/', // + id
                    changeStatusCererePriorityPublic:
                        'api/nomenclatoare/cerere-priority/public/', // + id
                    clearCache: 'api/nomenclatoare/cerere-priority/clear-cache',
                },
                cerereSabloane: {
                    getCerereSabloaneDT: 'api/nomenclatoare/cerere-sabloane/list-dt',
                    getCerereSabloane: 'api/nomenclatoare/cerere-sabloane/list',
                    getCerereSablon: 'api/nomenclatoare/cerere-sabloane/find/', // + id
                    putCerereSablon: 'api/nomenclatoare/cerere-sabloane/update', // id in payload
                    deleteCerereSablon: 'api/nomenclatoare/cerere-sabloane/delete/', // + id
                    storeCerereSablon: 'api/nomenclatoare/cerere-sabloane/store',
                    getCerereSabloaneActive:
                        'api/nomenclatoare/cerere-sabloane/list/active',
                    getCerereSabloaneActivePublic:
                        'api/nomenclatoare/cerere-sabloane/list/public',
                    changeStatusCerereSablonActive:
                        'api/nomenclatoare/cerere-sabloane/active/', // + id
                    changeStatusCerereSablonPublic:
                        'api/nomenclatoare/cerere-sabloane/public/', // + id
                },
                judet: {
                    getJudete: 'api/nomenclatoare/judet/list',
                    getJudeteDT: 'api/nomenclatoare/judet/list-dt',
                    getJudet: 'api/nomenclatoare/judet/find/', // + id
                    putJudet: 'api/nomenclatoare/judet/update', // id in payload
                    deleteJudet: 'api/nomenclatoare/judet/delete/', // + id
                    storeJudet: 'api/nomenclatoare/judet/store',
                    getJudeteActive: 'api/nomenclatoare/judet/list/active',
                    getJudeteActivePublic: 'api/nomenclatoare/judet/list/public',
                    changeStatusJudetActive: 'api/nomenclatoare/judet/active/', // + id
                    changeStatusJudetPublic: 'api/nomenclatoare/judet/public/', // + id
                },
                directie: {
                    getDirectii: 'api/nomenclatoare/directie/list',
                    getDirectiiActive: 'api/nomenclatoare/directie/list/active',
                },
                compartiment: {
                    getCompartimente: 'api/nomenclatoare/directie-compartiment/list',
                    getCompartimenteByDirectie:
                        'api/nomenclatoare/directie-compartiment/listByDirectie/',
                    getCompartimenteActive:
                        'api/nomenclatoare/directie-compartiment/list/active',
                    getCompartimenteByUrbanism: 'api/nomenclatoare/directie-compartiment/listByDirectieUrbanism',
                },
                user: {
                    getUsers: 'api/nomenclatoare/user/list',
                    getActiveUsersByOrganigrama:
                        'api/nomenclatoare/user/list-users-organigrama',
                    getUsersList: 'api/nomenclatoare/user/list-all-users',
                },
                documentType: {
                    list: 'api/nomenclatoare/document-types/list',
                    listDT: 'api/nomenclatoare/document-types/list-dt',
                    one: 'api/nomenclatoare/document-types/find/', // + id
                    update: 'api/nomenclatoare/document-types/update', // id in payload
                    delete: 'api/nomenclatoare/document-types/delete/', // + id
                    store: 'api/nomenclatoare/document-types/store',
                    clearCache: 'api/nomenclatoare/document-types/clear-cache',
                },
                documentCategory: {
                    list: 'api/nomenclatoare/document-categories/list',
                    listDT: 'api/nomenclatoare/document-categories/list-dt',
                    one: 'api/nomenclatoare/document-categories/find/', // + id
                    update: 'api/nomenclatoare/document-categories/update', // id in payload
                    delete: 'api/nomenclatoare/document-categories/delete/', // + id
                    store: 'api/nomenclatoare/document-categories/store',
                    clearCache: 'api/nomenclatoare/document-categories/clear-cache',
                },
                documentTemplate: {
                    list: 'api/nomenclatoare/document-templates/list',
                    listDT: 'api/nomenclatoare/document-templates/list-dt',
                    one: 'api/nomenclatoare/document-templates/find/', // + id
                    templateById: 'api/cerere/get-official-doc-template/',
                    update: 'api/nomenclatoare/document-templates/update', // id in payload
                    delete: 'api/nomenclatoare/document-templates/delete/', // + id
                    store: 'api/nomenclatoare/document-templates/store',
                    changeActive: 'api/nomenclatoare/document-templates/updateStatusActive/', // + id
                    signatures: {
                        getListIds:
                            'api/nomenclatoare/document-templates/signatures/allocated/', // + id template
                        updateIds:
                            'api/nomenclatoare/document-templates/signatures/allocated/', // + id template
                        updateOrder:
                            'api/nomenclatoare/document-templates/signatures/update-order/', // + id signature
                        updateSignType:
                            'api/nomenclatoare/document-templates/signatures/update-sign-type/', // + id
                        updateSignatures:
                            'api/nomenclatoare/document-templates/signatures/update-signatures',
                        updateCurrentSignature:
                            'api/nomenclatoare/document-templates/signatures/current/',
                    },
                },
                functiiUser: {
                    list: 'api/nomenclatoare/functie/list',
                    listActive: 'api/nomenclatoare/functie/list/active',
                },
                registre: {
                    list: 'api/document-oficial-registru/list',
                    listDT: 'api/document-oficial-registru/list-dt',
                    listActive: 'api/document-oficial-registru/list/active',
                    listPublic: 'api/document-oficial-registru/list/public',
                    store: 'api/document-oficial-registru/store',
                    update: 'api/document-oficial-registru/update',
                    updateSequence: 'api/document-oficial-registru/update-sequance/',
                    changeActive: 'api/document-oficial-registru/active/',
                    changePublic: 'api/document-oficial-registru/public/',
                    changeStatusCerereArchive: 'api/document-oficial-registru/archive/',
                    delete: 'api/document-oficial-registru/delete/',
                    find: 'api/document-oficial-registru/find/',
                },
                registru: {
                    list: 'api/registru/list',
                    listDT: 'api/registru/list-dt',
                    storeDocumentOficial: 'api/registru/document-oficial-add/', // + registru type id
                    editDocumentOficial: 'api/registru/document-oficial-edit/', // + registru type id,
                    exportRegister: 'api/registru/export',
                    exportCSVRegister: 'api/registru/export-csv',
                },
                operatori: {
                    getOperatoriDT: 'api/nomenclatoare/user/list-module-users',
                    getOperatorCerereById:
                        'api/nomenclatoare/user/list-cerere-types-user/', // + id
                    updateOperator: 'api/settings/operatori/update-cereri-permissions',
                    getOperatorPermisiuniList:
                        'api/settings/operatori/operator-cereri-permissions-list',
                    getOperatorFunctie: 'api/settings/operatori/operator-cereri-functie/', // user_id
                    updateOperatorFunctie:
                        'api/settings/operatori/operator-cereri-functie-update/', // user_id, payload {functie_id}
                    getOperatoriByCompartiment: 'api/settings/operatori/operator-compartment-list/', // ++ id_compartiment
                },
                zileLibere: {
                    getZileLibereList: 'api/nomenclatoare/zile/libere/list',
                    getZileLibereListDT: 'api/nomenclatoare/zile/libere/list-dt',
                    storeZileLibere: 'api/nomenclatoare/zile/libere/store',
                    updateZileLibere: 'api/nomenclatoare/zile/libere/update',
                    deleteZileLibere: 'api/nomenclatoare/zile/libere/delete/',
                },
                crons: {
                    list: 'api/nomenclatoare/cron/list',
                    listDT: 'api/nomenclatoare/cron/list-dt',
                    listActive: 'api/nomenclatoare/cron/list-active',
                    store: 'api/nomenclatoare/cron/store',
                    update: 'api/nomenclatoare/cron/update',
                    updateStatus: 'api/nomenclatoare/cron/change-status/',
                    delete: 'api/nomenclatoare/cron/delete/',
                },
                confirmareDocumente: {
                    getDocumenteCofirmareDT: 'api/confirmari/list-dt',
                    fileDownload: 'api/confirmari/download/', // + id
                },
            },
        },
        authCore: {
            basePath: 'https://development.auth-core.webproductionlabs.com/',
            linkRedirectAuth:
                'https://development.app.webproductionlabs.com/#/aplicatii',
            platform: {
                getUserDetails: 'api/user/1/1', // get user from token and also validate token for operator to autorize actions
                getUserPermissionsAuthLib:
                    'api/client/module/permission/user/getUserPermissionsAuthLib/',
            },
            nomenclatoare: {
                judet: {
                    list: 'api/judet/list',
                }
            }
        },
    },
};

/*
 *  To run this proper configuration, please use: ng serve
 */
